import { Bot, Mail, Bell, AlertTriangle } from "lucide-react";
import { formatDate } from "@/lib/format";

const text = (i) => (typeof i === "string" ? i : [i.cari, i.neden, i.ton && `(${i.ton})`].filter(Boolean).join(" · "));

export function AiBullets({ ai, labels }) {
  const entries = Object.entries(ai.content || {}).filter(([, v]) => v && v.length);
  return (
    <div className="panel p-4 border-l-4 border-l-violet-500" data-testid="ai-commentary">
      <div className="flex items-center gap-2 mb-2 text-[13px] font-semibold">
        <Bot className="h-4 w-4 text-violet-600" />Yorum & Öneriler
        <span className={`ml-auto text-[11px] px-2 py-0.5 rounded-full ${ai.status === "ok" ? "bg-violet-50 text-violet-700" : "bg-amber-50 text-amber-700"}`} data-testid="ai-status">
          {ai.status === "ok" ? `Yapay zekâ · ${ai.model}` : "Yedek özet (yapay zekâ kullanılamadı)"}
        </span>
      </div>
      {ai.note && <div className="text-[12px] text-slate-500">{ai.note}</div>}
      {ai.status !== "ok" && ai.error && <div className="text-[11px] text-amber-700 mb-2 flex gap-1" data-testid="ai-error"><AlertTriangle className="h-3.5 w-3.5" />{ai.error}</div>}
      <div className="grid md:grid-cols-2 gap-4">
        {entries.map(([k, items]) => (
          <div key={k} data-testid={`ai-block-${k}`}>
            <div className="text-[11px] uppercase tracking-wide text-slate-500 mb-1">{labels?.[k] || k}</div>
            <ul className="space-y-1.5">{items.map((i, n) => <li key={n} className="text-[13px] leading-snug flex gap-2"><span className="text-violet-500">•</span><span>{text(i)}</span></li>)}</ul>
          </div>
        ))}
      </div>
      <div className="text-[11px] text-slate-400 mt-3">Tüm sayılar ERP verisinden hesaplanır; yapay zekâ yalnızca yorum yazar{ai.dropped ? ` · doğrulamada ${ai.dropped} madde çıkarıldı` : ""}{ai.usage ? ` · ${ai.usage.total} token` : ""}</div>
    </div>
  );
}

function Section({ s }) {
  return (
    <div className="panel p-4 overflow-x-auto" data-testid={`ai-section-${s.key}`}>
      <div className="font-semibold text-[13px] mb-2">{s.title}</div>
      {s.rows.length === 0 ? <div className="text-[12px] text-slate-400">Kayıt yok</div> : (
        <table className="erp-table text-[12px]"><thead><tr>{s.cols.map((c, i) => <th key={i} className={i ? "text-right" : ""}>{c}</th>)}</tr></thead>
          <tbody>{s.rows.map((r, i) => <tr key={i}>{r.map((v, j) => <td key={j} className={j ? "text-right font-mono" : ""}>{v}</td>)}</tr>)}</tbody></table>)}
    </div>
  );
}

export function ReportView({ r }) {
  return (
    <div className="space-y-3" data-testid="ai-report-view">
      <div>
        <h2 className="text-lg font-semibold" data-testid="ai-report-title">{r.title}</h2>
        <div className="text-[12px] text-slate-500">{formatDate(r.created_at)} · {r.trigger === "manuel" ? r.created_by_name : "Zamanlayıcı"}</div>
      </div>
      <AiBullets ai={r.ai} labels={r.labels} />
      {r.sections.map((s) => <Section key={s.key} s={s} />)}
      {r.delivery?.length > 0 && (
        <div className="panel p-3 text-[12px]" data-testid="ai-delivery">
          <div className="font-semibold mb-1">Teslim durumu</div>
          {r.delivery.map((d) => (
            <div key={d.user_id} className="flex items-center gap-3 py-0.5">
              <span className="w-40 truncate">{d.name}</span>
              <span className="flex items-center gap-1 text-emerald-700"><Bell className="h-3 w-3" />bildirim</span>
              <span className={`flex items-center gap-1 ${d.email?.status === "gönderildi" ? "text-emerald-700" : d.email?.status === "hata" ? "text-rose-600" : "text-slate-500"}`}>
                <Mail className="h-3 w-3" />e-posta: {d.email?.status}{d.email?.detail && d.email.status !== "gönderildi" ? ` (${d.email.detail})` : ""}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
